// This file was automatically generated from appchart.dialog.ordermed.fulfillRefill.html.
// Please don't edit this file by hand.

goog.provide('el8.template.appchart.dialog.ordermed.fulfillRefill');

goog.require('soy');
goog.require('soy.StringBuilder');
goog.require('el8.template.data.practices');
goog.require('el8.template.render.header');
goog.require('el8.template.render.medOrder');
goog.require('el8.template.render.rxRefillRequest');


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.dialog.ordermed.fulfillRefill.content = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="overlayContainer">');
  if (opt_data.originalRefillRequest && opt_data.originalRefillRequest.requested_prescriber) {
    el8.template.data.practices.header({name: opt_data.originalRefillRequest.requested_prescriber.name, addressLine: opt_data.originalRefillRequest.requested_prescriber.address_line, cityStateZip: opt_data.originalRefillRequest.requested_prescriber.city_state_zip, phone: opt_data.originalRefillRequest.requested_prescriber.phone, fax: opt_data.originalRefillRequest.requested_prescriber.fax}, output);
  } else {
    el8.template.data.practices.header(opt_data.practice, output);
  }
  output.append('<h2 class="orderTitle"><span class="orderCategoryTitle elt">', (opt_data.mode == 'deny') ? 'Denial' : (opt_data.isControlled) ? 'Controlled Substance' : 'Prescription', '</span></h2>');
  el8.template.render.header.patientOrder(opt_data.patient, output);
  el8.template.render.rxRefillRequest.summary(soy.$$augmentData(opt_data.refill, {authRefills: opt_data.authRefills, note: opt_data.note, mode: opt_data.mode}), output);
  el8.template.render.medOrder.signature(opt_data, output);
  output.append('<div class="spacer"><p class="el8AppColor">Refill response will be sent electronically to the following pharmacy:</p>');
  el8.template.render.medOrder.pharmacy(opt_data.refill.pharmacy, output);
  output.append('</div></div>');
  if (!opt_sb) return output.toString();
};
